/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pxk_Confirm_CancelInputs */

const vi_pl_pxk_confirm_cancel = /** @type {(inputs: Pl_Pxk_Confirm_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy phiếu xuất lô chè mua này?`)
};

/**

* @param {Pl_Pxk_Confirm_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pxk_confirm_cancel = /** @type {((inputs?: Pl_Pxk_Confirm_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pxk_Confirm_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pxk_confirm_cancel(inputs)
});